























import { Component, PropSync, Prop } from 'vue-property-decorator'
import { Getter, Action } from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import { SelectWings, ToggleWings, FilterWings, FilterSelectedItemWings, InputWings } from 'wings-ui-components';
import { TemplatesFilterParams } from "@/store/sms/templates/types";
import { notifyError } from "@/utils/notify-helper";
import { MsgTransports } from '@/store/types';
import { getTranslatedParams } from '@/utils/notify-utils';

@Component({components: {FilterSelectedItemWings, SelectWings, ToggleWings, FilterWings, InputWings}})
export default class TemplatesFilter extends BaseFilter<TemplatesFilterParams> {
  @PropSync('show') is_show!: boolean;
  @Prop() transport!: MsgTransports;

  @Getter("templatesStatusList") statusList: any;
  @Getter("priorityList") priorityList: any;

  @Action("getTemplates") actionGetTemplates: any;
  @Action("exportTemplates") actionExportTemplates: any;
  @Action("actionLog") actionLog: any;

  emailTransport: MsgTransports = MsgTransports.EMAIL;
  log: boolean = false

  defaultFilter(): TemplatesFilterParams {
    return {
      name: undefined,
    }
  }

  storageItemName(): string {
    return `${this.transport}TemplateFilter`;
  }

  created() {
    this.filtered();
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: "Template",
        addititionalInfo: getTranslatedParams(this.filter)
      }
      this.actionGetTemplates({filter: this.filter, transport: this.transport});
      if (this.log) await this.actionLog(this.logObject)
      this.log = true
    } catch(error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  async export(): Promise<any> {
    try {
      this.actionExportTemplates({filter: this.filter, transport: this.transport})
    } catch(error) {
      notifyError(error);
    }
  };
}
